import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import Auth from './components/hoc/auth';
import Home from './components/Home';
import Login from './components/Login';
import EmployerAction from './components/EmployerAction';
import Loans from './components/Loans';
import LoanDetails from './components/LoanDetails';
import AllLoans from './components/AllLoans';
import Users from './components/Users';
import Mandates from './components/Mandates';
import Employer from './components/Employer';
import Clientdetails from './components/Clientdetails';
import Mandate from './components/Mandate';
import ReferenceMandates from './components/ReferenceMandates';


import 'bootstrap/dist/css/bootstrap.min.css';
import './css/custom.css';

{ /*

  <Route path="/" exact component={Auth(Home,null)}/>
<Route path="/login" exact component={Auth(Login,false)}/>
<Route path="/user/logout" exact component={Auth(Logout,true)}/>
<Route path="/user" exact component={Auth(User,true)}/>
<Route path="/user/add" exact component={Auth(AddReview,true)}/>
<Route path="/user/register" exact component={Auth(Register,true)}/>
<Route path="/user/edit-post/:id" exact component={Auth(EditReview,true)}/>
<Route path="/books/:id" exact component={Auth(BookView,null)}/>
<Route path="/user/user-reviews" exact component={Auth(UserPosts,true)}/> */ }

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={Auth(Login, false, 'login')} />
      <Route path="/dashboard" exact component={Auth(Home, true)} />
      <Route path="/clientdetails/:id" exact component={Auth(Clientdetails, true)} />

      <Route path="/employer" exact component={Auth(Employer, true)} />

      <Route path="/allloans" exact component={Auth(AllLoans, true)} />
      <Route path="/loans/:clientId/:clientName" exact component={Auth(Loans, true)} />
      <Route path="/users" exact component={Auth(Users, true)} />
      <Route path="/LoanDetails/:loanId" exact component={Auth(LoanDetails, true)} />
      <Route path="/EmployerAction" exact component={EmployerAction} />
      <Route path="/mandates" exact component={Auth(Mandates, true)} />
      <Route path="/mandates/:clientId" exact component={Auth(Mandates, true)} />
      <Route path="/referencemandates/:client" exact component={Auth(ReferenceMandates, true)} />


      <Route path="/mandate/:hash" exact component={Mandate} />

    </Switch>
  </BrowserRouter>,
  document.getElementById('root'),
);
